import { FETCH_GROUPS_LIST,FETCH_GROUPS_VIEW_LIST, FETCH_GROUP_TYPE } from "../actions/type";

const initialState = {
    user: [],

    config: [],
    hr_permission: [],
    manager_permission: '',

    permissions: [],


    item_count: '',
    activePage: '',
    off_count: '',
    offset: '',
    get_group_type: [],
    member_email: [],
    member_emailgroup: [],
    pod: [],
    group_users: [],
    trrop_details:[],
    loading:true

}

const manageGroupsReducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case FETCH_GROUPS_LIST:
            return {
                ...state,
                user: [...action.users],

                hr_permission: action.hr_permission,
                manager_permission: action.manager_permission,
                config: [...action.config],
                permissions: [...action.permissions],

                item_count: action.item_count,
                activePage: action.pageNumber,
                off_count: action.off_count,
                offset: action.offset,
                loading:false

            }

            break;
        case FETCH_GROUP_TYPE:
            return {
                ...state,
                get_group_type: [...action.get_group_type],
                member_email: [...action.member_email],
                member_emailgroup: [...action.member_emailgroup],
                pod: [...action.pod],
                loading:false

            }
            break;
            case FETCH_GROUPS_VIEW_LIST:
                return {
                    ...state,
                    group_users: [...action.group_users],
                    group_count: [action.group_count],
                    group_name: [action.group_name],
                    group_type_name:[action.group_type_name],
                    hr_permission:[action.hr_permission],
                    description: [action.description],
                    trrop_details: [...action.trrop_details],
                    group_id: [action.group_id],
                    loading:false
                }

        default:
            break;
    }
    return newState;
}

export { manageGroupsReducer }


// WEBPACK FOOTER //
// ./src/reducers/manageGroupsReducer.js